import { QuoteSlice as QuoteSliceCL } from '@comicrelief/component-library';
import { getImage } from 'gatsby-plugin-image';
import { get, snakeCase } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import imagePropType from '../../commonPropTypes/commonPropTypes';
import { paddingOptionMapping } from '../../utils/optionMapping';

const QuoteSlice = ({ data }) => {
  const {
    title,
    heading,
    body,
    imageL,
    imageM,
    imageS,
    ctaUrl,
    ctaLabel,
    paddingAbove,
    paddingBelow,
    ...cmsData
  } = data;
  // process CMS setting values into component-friendly values
  // images and placeholders
  const imageLarge = getImage(imageL);
  const imageMedium = getImage(imageM);
  const imageSmall = getImage(imageS);
  const imageLargePlaceholder = imageLarge?.placeholder?.fallback;
  const imageMediumPlaceholder = imageMedium?.placeholder?.fallback;
  const imageSmallPlaceholder = imageSmall?.placeholder?.fallback;
  const imageLargeSrcSet = imageLarge?.images?.sources[0]?.srcSet;
  const imageMediumSrcSet = imageMedium?.images?.sources[0]?.srcSet;
  const imageSmallSrcSet = imageSmall?.images?.sources[0]?.srcSet;

  // page background and text colour
  const pageBackgroundColour = snakeCase(cmsData.pageBackgroundColour) || undefined;
  const textColour = snakeCase(cmsData.textColour) || undefined;

  // padding
  const componentPaddingTop = get(paddingOptionMapping, paddingAbove);
  const componentPaddingBottom = get(paddingOptionMapping, paddingBelow);

  return (
    <QuoteSliceCL
      key={title}
      heading={heading?.heading}
      body={body?.body}
      imageS={imageSmallSrcSet}
      imageSPlaceholder={imageSmallPlaceholder}
      imageM={imageMediumSrcSet}
      imageMPlaceholder={imageMediumPlaceholder}
      imageL={imageLargeSrcSet}
      imageLPlaceholder={imageLargePlaceholder}
      ctaUrl={ctaUrl}
      ctaLabel={ctaLabel}
      pageBackgroundColour={pageBackgroundColour}
      textColour={textColour}
      paddingTop={componentPaddingTop}
      paddingBottom={componentPaddingBottom}
    />
  );
};

QuoteSlice.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    heading: PropTypes.shape({
      heading: PropTypes.string
    }),
    body: PropTypes.shape({
      body: PropTypes.string
    }),
    imageS: imagePropType,
    imageM: imagePropType,
    imageL: imagePropType,
    ctaUrl: PropTypes.string,
    ctaLabel: PropTypes.string,
    pageBackgroundColour: PropTypes.string,
    textColour: PropTypes.string,
    paddingAbove: PropTypes.string,
    paddingBelow: PropTypes.string
  }).isRequired
};

export default QuoteSlice;
